module.exports = __webpack_public_path__ + "img/MCD.aeb95d34.png";